/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect, useState, Children, cloneElement } from 'react';
import { findDOMNode } from 'react-dom';
import FormContainer from '../FormContainer';
import { CardHeader, Container, PopUpMenu, ItemMenu } from './styles'
import PropTypes from 'prop-types';
import { Icon } from 'components';

const propTypes = {
  title: PropTypes.string,
};

export default function GroupFormContainer({
  children,
  hide,
  isChild,
  CustomColor,
}) {

  const [showPopUp, setShowPopUp] = useState(false);
  const [collapseAll, setCollapseAll] = useState(null);
  const [collapseChild, setCollapseChild] = useState(null);
  const containerRef = React.createRef();
 
 const handleCollapse = (isChild = false) => {
  if (isChild) return setCollapseChild(collapseChild === null ? true : !collapseChild);
  setCollapseAll(collapseAll === null ? true : !collapseAll);
  };

 if (hide) return <div style={{ display: 'none' }} >{children}</div>;

  return (
    <Container className="collapsed-div">
      <CardHeader customColor={CustomColor}>
        <h1 onClick={() => setShowPopUp(!showPopUp)}>...</h1>
        <PopUpMenu className={showPopUp ? 'fadeInLeft' : 'fadeOutLeft'}>
         
          <ItemMenu onClick={() => { setTimeout(() => { handleCollapse(); setShowPopUp(!showPopUp) }, 100) }}>
            <Icon className={collapseAll ? '' : 'closed'} name="arrow-up-primary-color" />
            {`${collapseAll ? 'Esconder' : 'Expandir'} todos os Grupos`}
          </ItemMenu>

          {isChild && <ItemMenu onClick={() => { setTimeout(() => { handleCollapse(true); setShowPopUp(!showPopUp) }, 100) }}>
            <Icon className={collapseChild ? '' : 'closed'} name="arrow-up-primary-color" /> 
            {`${collapseChild ? 'Esconder' : 'Expandir'} todos os Sub-Grupos`}
          </ItemMenu>}

        </PopUpMenu>
      </CardHeader>
      <div ref={containerRef}>{children(handleCollapse, collapseAll, collapseChild)}</div>
    </Container>
  );
}

GroupFormContainer.propTypes = propTypes;